function FileUpload() {
	var $Selector = $('.input--file');
	var $ShowName = $('.input__filename');
	$Selector.change(function() {
		$ShowName.text(this.files[0].name);
	});
}

function SetFileUploadInBackground() {
	var $FileUploadInput = $('.file--preview');
	var $PreviewArea = $('.file__area--preview');


	$FileUploadInput.each( function () {
		$(this).change(function () {
			var $this = $(this);
			var file = this.files[0];
			var reader = new FileReader();
			if (file) {
				reader.readAsDataURL(file);

				reader.onloadend = function () {
					$this.parent().find('.file__area--preview').css('background-image', 'url("' + reader.result + '")');
				};
			} else {
				return false;
			}
		});
	});
}

function DragandDrop() {
	var $dragable = $('.file--dragable');
	var $text_area = $('.file__area');
	var $file_Name = $('.file__area-des');
	var $file_Info = $('.file__info');

	$dragable.change(function() {
		var file = this.files;
		var $text_area = $(this).parent();
		var lengh = file.length;
		if (lengh > 1) {
			for (var i = 0; i <= file.length - 1; i++) {
				console.log(file[i]);
			}
		} else {
			$file_Name.text(file[0].name);
			$file_Info.text('فرمت: ' + file[0].type + ', ' + Math.round(file[0].size / 1024) + ' KB');
			$file_Info.css('display', 'block');
		}
	});

	$dragable.on('focus', function() {
		$(this).parent().addClass('focus');
	});

	$dragable.on('blur', function() {
		$(this).parent().removeClass('focus');
	});
}

function ChangeLabelColor() {
	$('.form__box').each(function() {
		$(this).find('input[type="text"], input[type="password"] , textarea').focusin(function() {
			$(this).parent().find('label').css('color', '#FEA000');
		});

		$(this).find('input , textarea').focusout(function() {
			$(this).parent().find('label').css('color', '');
			$(this).parent().css('background-color', '');
			$(this).parent().css('border-color', '');
		});
	});
}

function CheckPassword() {
	var result = $("#password-strength");

	var $Password_Input = $('.checkpass');
	var $passStrong = $('.checkpass__progress');
	var $passStrong_Text = $('.checkpass__text');

	$Password_Input.keyup(function() {
		$passStrong_Text.html(checkStrength($Password_Input.val()))
	});

	function checkStrength(password) {

		//initial strength
		var strength = 0;

		if (password.length == 0) {
			$passStrong.removeClass();
			return ''
		}
		//if the password length is less than 7, return message.
		if (password.length < 9) {
			$passStrong.removeClass();
			$passStrong.addClass('checkpass__progress normal');
			return 'متوسط'
		}

		//length is ok, lets continue.

		//if length is 8 characters or more, increase strength value
		if (password.length > 9) strength += 1

		//if password contains both lower and uppercase characters, increase strength value
		if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) strength += 1

		//if it has one special character, increase strength value
		if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1

		//if it has two special characters, increase strength value
		if (password.match(/(.*[!,%,&,@,#,$,^,*,?,_,~].*[!,",%,&,@,#,$,^,*,?,_,~])/)) strength += 1

		//now we have calculated strength value, we can return messages

		//if value is less than 2
		if (strength < 2) {
			$passStrong.removeClass();
			$passStrong.addClass('checkpass__progress medium');
			return 'متوسط'
		} else if (strength == 2) {
			$passStrong.removeClass();
			$passStrong.addClass('checkpass__progress strong');
			return 'خوب'
		} else {
			$passStrong.removeClass();
			$passStrong.addClass('checkpass__progress vstrong');
			return 'عالی'
		}
	}
}

function LiveSearch() {
	var $input = $('.livesearch__input');
	var $list = $('.livesearch__list');
	var $mainInput = $('.input--search');

	/* Change Focus and Show Box When Click on Input */
	$mainInput.on('focus',function () {
		$(this).attr('value','');
		$(this).parent().addClass('openbox');
		$('.livesearch').addClass('show');
		$input.focus();
	});

	/* Start Filtering */
	$input.on('keyup',function () {
		var term = $input[0].value;
		var tag = document.querySelectorAll('.livesearch__list li span');

		for (i=0;i<tag.length;i++){
			if (tag[i].innerHTML.indexOf(term) !== -1){
				tag[i].parentElement.style.display = 'flex'
			} else {
				tag[i].parentElement.style.display = 'none'
			}
		}
	});

	/* Close Box after user Select Item */
	$list.find('li').on('click',function () {
		var text = $(this).find('span').text();
		var value = $(this).attr('data-fieldvalue');
		$mainInput.attr('value',text);
		$mainInput.attr('data-value', value);
		$mainInput.parent().removeClass('openbox');
		$('.livesearch').removeClass('show');
	});

	/* Close Box after User Change Focus */
	$document.on('click.show-livesearch', function(event) {
		if (!$(event.target).closest('.form__box--livesearch').length) {
			$mainInput.parent().removeClass('openbox');
			$('.livesearch').removeClass('show');
		}
	});

}

function ImageLabelBox() {

	var $ImageLabel = $('.form__box--imagelabel');
	var $CheckBox = $ImageLabel.find('.input--checkbox');

	$CheckBox.each( function () {
		$(this).on('click',function () {
			var $this = $(this);
			$this.parents('.form__box--imagelabel').toggleClass('checked');
		});
	});

	$ImageLabel.each( function () {
		$(this).on('click',function () {
			var $this = $(this);
			var status = $this.find('.input--checkbox').prop('checked');
			$this.find('.input--checkbox').prop('checked', !status );
			$this.toggleClass('checked');
		});
	});
}

function ImageRadio() {
	var $ImageLabel = $('.form__box--radioimage');

	$ImageLabel.each( function () {
		$(this).on('click',function () {
			var $this = $(this);
			var status = $this.find('.input').prop('checked');
			if( status !== true ) {
				$this.parent().parent().find( $ImageLabel ).removeClass('checked');
				$this.find('.input').prop('checked', !status);
				$this.toggleClass('checked');
			}
		});
	});
}

function CatRadio() {
	var $ImageLabel = $('.form__box--radiocat');

	$ImageLabel.each( function () {
		var Color = $(this).attr('data-color');
		$(this).css('color', Color);

		$(this).on('click',function () {
			var $this = $(this);
			var status = $this.find('.input').prop('checked');
			if( status !== true ) {
				$this.parent().parent().find( $ImageLabel ).removeClass('checked');
				$this.find('.input').prop('checked', !status);
				$this.toggleClass('checked');
			}
		});
	});
}

function CheckBoxLabelWithoutHover() {
	var $checkBox = $('.form__box--checkbox');
	var $Label = $checkBox.find('.form__label');

	$Label.each( function () {
		$(this).on('click',function () {
			var $this = $(this);
			var status = $this.parent().find('.input--checkbox').prop('checked');
			$this.parent().find('.input--checkbox').prop('checked', !status);
		});
	});

}

function TagInput() {
	var tagWrapper = $('.tag__list');
	var tagField = $('.tag');


		/* add tag function */
	function addTag(tag) {
		tag = tag || '';

		if (tag.length > 0) {
			var newTag = '<li class="tag__list-item"><span class="tag__list-item-action"></span>'+ tag +'</li>';
			tagWrapper.append(newTag);
		}
	}

	tagField.on('keydown',function (e){
		if (e.keyCode === 13 && e.target.value !== '') {
			Text = e.target.value;
			addTag( Text );
			e.target.value = '';
		}
	});

	$(document).on('click','.tag__list-item-action',function(e) {
		$(this)[0].parentNode.remove();
	});

}

function GalleryNodeDuplicator() {
	var BaseNode = $('.add-product__gallery-col.duplicate');
	var DuplicatorBtn = $('.add-product__gallery-addcol');

	DuplicatorBtn.on('click',function () {
		var $cloneNode = BaseNode.clone().removeClass('duplicate');
		var $Selector = $(this).parent();
		$cloneNode.appendTo( $Selector ).insertBefore( $(this) );
		return false;
	});
}

$(function() {
	FileUpload();
	ChangeLabelColor();
	DragandDrop();
	CheckPassword();
	LiveSearch();
	SetFileUploadInBackground();
	ImageLabelBox();
	ImageRadio();
	CatRadio();
	CheckBoxLabelWithoutHover();
	if ($('.page-add-product').length > 0) {
		TagInput();
	}
	GalleryNodeDuplicator();
});